// Axios
import axios from 'axios'

export const getPlacesAutocompleteApi = (input) => new Promise((resolve, reject) => {
  axios.post(
    'https://places.googleapis.com/v1/places:autocomplete',
    {
      input,
      includedRegionCodes: ["id"],
      includeQueryPredictions: true
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': process.env.VUE_APP_GOOGLE_MAP_API_KEY,
        'X-Goog-FieldMask':
          'suggestions.placePrediction.placeId,' +
          'suggestions.placePrediction.structuredFormat.mainText.text,' +
          'suggestions.placePrediction.structuredFormat.secondaryText.text'
      }
    }
  )
    .then(resolve)
    .catch(reject)
})


export const getPlacesAutocomplete = async function (input) {
  try {
    const res = await getPlacesAutocompleteApi(input)
    return res.data.suggestions
  } catch (error) {
    return []
  }
}